import Api from '@op/api-base';

const LOGIN_MODEL_URL = '/loginmodel';
const REPRESENTATION_MODEL_URL = '/representationmodel';

class RestApi {
    constructor() {
        const url = `${window.location.pathname}/rest`.replace('/representation', '').replace('//', '/');
        this._api = new Api(url);
    }

    getLoginModel() {
        return this._api.get(LOGIN_MODEL_URL, getConfig());
    }

    getRepresentationModel() {
        return this._api.get(REPRESENTATION_MODEL_URL, getConfig());
    }
}

const getConfig = (args = {}) => ({
    headers: { Accept: 'application/json' },
    query: getQueryParams(),
    ...args,
});

const getQueryParams = () => {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    return Object.fromEntries(params);
};
const restApi = new RestApi();
export default restApi;
